/**
 * 适配器抽象类
 *
 * @export
 * @class AbstractAdapter
 */
export default class AbstractAdapter {
  constructor() {
    // log.error("can not construct in a abstract class, implement in subclass.");
    // 不支持标准的抽象类， 子类必须在构造函数内进行super操作
  }

  init(opts = {}) {
    this._opts = opts;
    // {"show_page":0,"show_step":0,"converted_page":31,"status":200,"converted_page_jpeg":31,"status_jpeg":200,"hash":"a42e11a947eab30a1ba1bde4fd7b8aee","ext":"pptx","page":31,"width":"800","height":"450","document_server":"t-static01-open.e.vhall.com/document","log_info":{"session_id":"aa32fd92_15511682109501551168221717","uid":"aa32fd92_1551168210950","ip":"10.10.200.219","third_party_user_id":"1551168210950","account_id":760,"app_name":"测试微吼云应用"},"backgroundColor":"#ffc0f000","urlBase":"//t-static01-open.e.vhall.com/document/","uploadBase":"//upload.vhall.com/"}
    this._reset();
    this._docType = '';
    this._ext = opts.ext;
    this._hash = opts.hash || '';
    const passThrough = this.store.getKV('passThrough');
    const { docId, userId } = passThrough;
    this._info = {
      slidesTotal: opts.slidesTotal || opts.page || opts.converted_page || 0,
      slideIndex: opts.slideIndex || opts.show_page || 0,
      stepIndex: opts.stepIndex || opts.show_step || 0,
      pageHash: `${this._hash}/${opts.show_page}` || '',
      hash: opts.hash || '',
      userId,
      docId
    };
  }

  createEl(id) {}

  /**
   * 下一页
   *
   * @memberof AbstractAdapter
   */
  nextPage() {
    this.currentPageId += 1;
    this.currentPageId = Math.min(this.currentPageId, this.totalPage - 1);
  }

  /**
   * 上一页
   *
   * @memberof AbstractAdapter
   */
  prevPage() {
    this.currentPageId -= 1;
    this.currentPageId = Math.max(0, this.currentPageId);
  }

  /**
   * 跳转到某一页
   *
   * @param {*} id
   * @memberof AbstractAdapter
   */
  gotoPage(id) {
    this.currentPageId = Math.limitIn(id, 0, this.totalPage - 1);
  }

  /**
   * 上一步， 非PPT没有上一步的功能，走上一页的逻辑
   *
   * @memberof AbstractAdapter
   */
  prevStep() {}

  /**
   * 下一步，非PPT没有下一步的功能，走下一页的逻辑
   *
   * @memberof AbstractAdapter
   */
  nextStep() {}

  /**
   * 跳转到某一页的某一个动画步骤，非PPR只跳转到相应页码，也就是只取第一个参数
   *
   * @param {*} args
   * @memberof AbstractAdapter
   */
  gotoStep(...args) {}

  /***
   * 非PPT没有播放功能
   */
  play() {}

  /***
   * 非PPT没有暂停功能
   */
  pause() {}

  /**
   * 设置文档大小
   *
   * @param {*} w
   * @param {*} h
   * @memberof AbstractAdapter
   */
  resize(w, h) {}

  /**
   * 销毁方法
   *
   * @memberof AbstractAdapter
   */
  destroy() {
    this._reset();
  }

  setSelected(val) {}

  _reset() {
    this._imgSize = {
      width: 0,
      height: 0
    };
    this._info = {
      slidesTotal: 0,
      slideIndex: 0,
      stepIndex: 0,
      pageHash: '',
      stepsAll: [],
      hash: ''
    };
    this._ext = '';
    // this._initCompleteCallBK = null
    this._inited = false;
  }

  /**
   * 文档hash
   *
   * @memberof AbstractAdapter
   */
  set hash(v) {
    this._info.hash = v;
  }

  get hash() {
    return this._info.hash;
  }

  /**
   * 信道ID
   *
   * @memberof AbstractAdapter
   */
  set cid(cid) {
    this._cid = cid;
  }

  get cid() {
    return this._cid;
  }

  /**
   * 获取当前页码hash
   *
   * @readonly
   * @memberof AbstractAdapter
   */
  get currentPageHash() {
    let hash = `${this.info.hash}/${this.info.slideIndex}`;
    this._info.pageHash = hash;
    return hash;
  }

  /**
   * 拿到文档的基础信息
   *
   * @readonly
   * @memberof AbstractAdapter
   */
  get info() {
    return this._info;
  }

  get ext() {
    return this._ext;
  }

  get opts() {
    return this._opts;
  }

  set inited(v) {
    this._inited = v;
  }

  get inited() {
    return this._inited;
  }

  set initCompleteCallBK(v) {
    this._initCompleteCallBK = v;
  }

  get initCompleteCallBK() {
    return this._initCompleteCallBK;
  }

  get imageSize() {
    return this._imgSize;
  }

  set imageSize(v) {
    this._imgSize = v;
  }

  /**
   * 获取当前文件的显示类型
   *
   * @readonly
   * @memberof AbstractAdapter
   * @returns h5 | jpg
   */
  get docType() {
    return this._docType;
  }

  get totalPage() {
    return this.info.slidesTotal;
  }

  set currentPageId(v) {
    this.info.slideIndex = v;
  }

  get currentPageId() {
    return this.info.slideIndex;
  }

  set store(val) {
    this._store = val;
    this._ee = this.store.getKV('ee');
  }

  get store() {
    return this._store;
  }
}
